import { Link } from 'react-router-dom';

const footerLinks = {
  内容分类: [
    { label: '电视剧', path: '/category/dianshiju' },
    { label: '电影', path: '/category/dianying' },
    { label: '综艺', path: '/category/zongyi' },
    { label: '纪录片', path: '/category/jilupian' },
    { label: '动漫', path: '/category/dongman' },
    { label: '少儿', path: '/category/shaocr' },
  ],
  关于我们: [
    { label: '品牌介绍', path: '/about' },
    { label: '发展历程', path: '/about' },
    { label: '联系方式', path: '/about' },
    { label: '荣誉资质', path: '/about' },
  ],
  帮助中心: [
    { label: '常见问题', path: '/' },
    { label: '会员服务', path: '/about' },
    { label: '版权声明', path: '/about' },
    { label: '隐私政策', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="text-xl font-heading font-bold text-background-50">
                国产精品在线
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              汇聚海量正版高清国产内容，涵盖影视、综艺、纪录片等多元品类，随时随地享受优质国产文化精品。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-100 mb-4">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 国产精品在线 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">
              服务条款
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">
              版权声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}